
<template>
  <div>
    <div class="flx-center">
            <div class="businessBackground" :style="{ background: 'url(' + $ossUrl + 'images/关于我们.jpg) no-repeat center', backgroundSize: '100%' }"></div>
        </div>
  <div class="" style="background-color: #f8f8f8;padding-bottom: 248px;">
     <div class="container" style="padding-top: 140px;">
      <el-row>
        <el-col :span="12" v-for="(item,index) in inviteList" :key="index" >
          <div 
          class="flx-only-align-center  "   
          :class="['inviteBox', { 'invite-active': inviteIndex === index }]"
          @click="setInviteActive(item,index)"
          >
              <img :src="item.img">
              <span>{{ item.title }}</span>
          </div>
        </el-col>
      </el-row>
     </div>
  </div>
  </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
    name:"about",
  components: {
  },
  created(){
 
  },
  data(){
    return {
      inviteIndex:0,
      inviteList: [
        { id:'1', img:this.$ossUrl+'icons/about/invite/icon1.png', title: '仓储类'},
        { id:'2', img:this.$ossUrl+'icons/about/invite/icon2.png', title: '海运操作类'},
        { id:'3', img:this.$ossUrl+'icons/about/invite/icon3.png', title: '空运操作类'},
        { id:'4', img:this.$ossUrl+'icons/about/invite/icon4.png', title: '海运产品类'},
        { id:'5', img:this.$ossUrl+'icons/about/invite/icon5.png', title: '财务类'},
        { id:'6', img:this.$ossUrl+'icons/about/invite/icon6.png', title: '研发类'},
        { id:'7', img:this.$ossUrl+'icons/about/invite/icon7.png', title: '人力资源类'},
        { id:'8', img:this.$ossUrl+'icons/about/invite/icon8.png', title: '海外仓类'},
        { id:'9', img:this.$ossUrl+'icons/about/invite/icon9.png', title: '销售类'},
        { id:'10',img:this.$ossUrl+'icons/about/invite/icon10.png', title: '客服类'},
        { id:'11',img:this.$ossUrl+'icons/about/invite/icon11.png', title: '采购/理赔类'},
        { id:'12',img:this.$ossUrl+'icons/about/invite/icon12.png', title: '总经办'},
        { id:'13',img:this.$ossUrl+'icons/about/invite/icon13.png', title: '市场品牌类'},
      ],
    
    }
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
      },
    setInviteActive(item,index) {
        this.inviteIndex = index
        localStorage.setItem('inviteIndex',JSON.stringify({index:index,activeName:'four'}));
         this.$router.push({
           name: 'inviteList',
           query:{
             id:item.id
           }
         });
      

    },
  }
};
</script>
<style src="../index.css" scoped></style>